module.exports = __webpack_public_path__ + "static/media/8.a59b1f0a.JPG";